module.exports = __webpack_public_path__ + "static/media/guide3.816ec80a.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/images/guide3.png
// module id = 391
// module chunks = 0